<template>
  <div>
    <h1 v-if="title" class="text-center mt-24 mb-12">{{ title }}</h1>
    <div v-for="(block, blockIndex) in blocks" :key="blockIndex">
      <div v-if="blockIsType(block, 'text')" v-html="block.text" class="max-w-2xl mx-auto my-12"></div>
      <div
        v-else-if="blockIsType(block, 'images') && block.content.type === 'inline' && block.content.images.length !== 0"
        class="w-full mx-auto my-12"
        :class="{ 'max-w-6xl': block.content.size === 'large', 'max-w-4xl': block.content.size === 'medium' }"
      >
        <figure
          v-for="(image, imageIndex) in block.images"
          :key="blockIndex + '-' + imageIndex"
          class="w-full pb-12 last:pb-0"
        >
          <div
            class="relative w-full"
            :style="calcAspectRatioPadding(image)"
          >
            <img
              class="absolute top-0 left-0 w-full h-full object-contain"
              v-lazy="image.src"
              :data-srcset="image.srcset"
            />
          </div>
          <figcaption class="text-sm text-center mt-2" v-html="image.content.caption"></figcaption>
        </figure>
      </div>
      <div
        v-else-if="blockIsType(block, 'images') && block.content.type === 'gallery' && block.images.length !== 0"
        class="mx-auto my-0"
        :class="{ 'max-w-6xl': block.size === 'large', 'max-w-4xl': block.size === 'medium' }"
      >
        <ImageCarousel :images="block.images" />
      </div>
      <div v-else-if="blockIsType(block, 'media') && validateVideoUrl(block.content.url)"  class="max-w-2xl mx-auto my-12" v-bind:class="{ 'max-w-6xl': block.content.size === 'large' }">
        <vue-plyr>
          <div :data-plyr-provider="getVideoUrlProvider(block.content.url)" :data-plyr-embed-id="getVideoUrlId(block.content.url)"></div>
        </vue-plyr>
        <div v-if="block.content.caption" class="text-sm text-center my-4" v-html="block.content.caption"></div>
      </div>
      <div v-else-if="blockIsType(block, 'iframe')"  class="max-w-2xl mx-auto my-12" v-bind:class="{ 'max-w-6xl': block.content.size === 'large' }">
        <iframe :src="block.content.url" />
        <div v-if="block.content.caption" class="text-sm text-center my-4" v-html="block.content.caption"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateVideoUrl, getVideoUrlProvider, getVideoUrlId } from '@/util'
import ImageCarousel from '@/components/ImageCarousel'

export default {
  name: 'ContentBlock',

  components: {
    ImageCarousel
  },

  props: ['title', 'blocks'],

  methods: {
    blockIsType(block, type) {
      return [block._key, block.type].includes(type)
    },

    calcAspectRatioPadding (image) {
      if (!image || !image.dimensions) {
        return ''
      }

      return `padding-top:calc(100%/(${image.dimensions.width}/${image.dimensions.height}));`
    },
    validateVideoUrl,
    getVideoUrlProvider,
    getVideoUrlId
  },

  mounted() {
    this.blocks.forEach(block => {
      if (block.images) {
        console.log('block.images', block.images)
      }
    })
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  min-height: 400px;
  height: 45vh;
  border: 1px solid black;
}
</style>
